<template>
  <div class="home list_index" ref="mainbox">
    <!-- <div class="canvas">
      <iframe frameborder="0" src="../../public/static/index.html" style="width: 100%; height: 100%"></iframe>
    </div> -->
    <div class="head">
      <h1>Kerry Cloud工业物联网云平台</h1>
      <div class="weather">
        <!--<img src="picture/weather.png"><span>多云转小雨</span>-->
        <span id="showTime" ref="showTime"></span>
        <img
          v-if="Screen == false"
          @click="screen"
          src="../assets/images/fangda.png"
          id="fullScreenBtn"
        />
        <img
          v-else-if="Screen == true"
          @click="screen"
          src="../assets/images/suoxiao.png"
          id="notFullScreenBtn"
        />
      </div>
    </div>
    <div class="mainbox">
      <ul class="clearfix">
        <li>
          <!-- <div class="boxall" style="height: 1.6rem">
            <div class="alltitle">设备在线率</div>
            <div class="allnav" id="onLine"></div>
          </div> -->
          <div class="boxall" style="height: 1.6rem;padding-top:.1rem">
            <div
              class="alltitle"
              style="cursor: pointer;"
              @click="toProjectScene"
            >
              在线设备列表
            </div>
            <el-radio-group
              v-model="device_status"
              class="radio"
              @change="adtiveNameChange"
              size="mini"
            >
              <el-radio-button label="0">{{ $t("whole") }}</el-radio-button>
              <el-radio-button label="3">运行</el-radio-button>
              <el-radio-button label="1">{{ $t("offLine") }}</el-radio-button>
            </el-radio-group>
            <!-- <div class="allnav" id="echart2"></div> -->
            <el-table
              stripe
              border
              :data="device_tableData"
              :row-style="{ height: '0' }"
              :cell-style="{ padding: '1px' }"
              @row-dblclick="control"
            >
              <el-table-column
                label="项目编号"
                align="center"
                prop="project_number"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <el-button type="text" @click="control(scope.row)">{{
                    scope.row.project_number
                  }}</el-button>
                </template>
              </el-table-column>
              <el-table-column
                label="电机电流"
                align="center"
                prop="electricCurrent"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <p v-if="scope.row.electricCurrent">
                    {{ scope.row.electricCurrent }} A
                  </p>
                </template>
              </el-table-column>
              <el-table-column
                label="排气压力"
                align="center"
                prop="pressure"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <p v-if="scope.row.pressure">{{ scope.row.pressure }} Mpa</p>
                </template>
              </el-table-column>
              <el-table-column label="状态" align="center" prop="device_status">
                <template slot-scope="scope">
                  <el-tag
                    type="success"
                    effect="dark"
                    v-if="
                      scope.row.device_status != '1' &&
                        scope.row.run_status == '1'
                    "
                    >运行</el-tag
                  >
                  <el-tag
                    type="warning item"
                    effect="dark"
                    v-if="
                      scope.row.device_status != '1' &&
                        scope.row.shutdown_status == '1'
                    "
                    >故障</el-tag
                  >
                  <el-tag
                    type="danger item"
                    effect="dark"
                    v-if="
                      scope.row.device_status != '1' &&
                        scope.row.standby_status == '1'
                    "
                    >待机</el-tag
                  >
                  <el-tag
                    type="danger item"
                    effect="dark"
                    v-if="scope.row.device_status == '4'"
                    >停机</el-tag
                  >
                  <el-tag
                    class="tag_alarm item"
                    effect="dark"
                    v-if="
                      scope.row.device_status != '1' &&
                        scope.row.alarm_status == '1'
                    "
                    >报警</el-tag
                  >
                  <el-tag
                    type="info"
                    effect="dark"
                    v-if="scope.row.device_status == '1'"
                    >离线</el-tag
                  >
                </template>
              </el-table-column>
            </el-table>
            <div class="pagination">
              <el-pagination
                layout="total, prev, pager, next"
                :current-page="device_page"
                :page-size="device_size"
                :total="device_count"
                :pager-count="4"
                @current-change="deviceChangePage"
              ></el-pagination>
            </div>
          </div>
          <div class="boxall" style="height: 1.6rem;padding-top:.1rem">
            <div class="alltitle">报警故障设备列表</div>
            <!-- <div class="allnav" id="echart1"></div> -->
            <el-table
              stripe
              border
              :data="notice_tableData"
              :row-style="{ height: '0' }"
              :cell-style="{ padding: '8px' }"
            >
              <el-table-column
                label="项目编号"
                prop="itemNo"
                align="center"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                label="报警描述"
                prop="alarmDescription"
                :show-overflow-tooltip="true"
                align="center"
              ></el-table-column>
              <el-table-column
                label="时间"
                prop="date"
                :show-overflow-tooltip="true"
                align="center"
              ></el-table-column>
              <el-table-column
                label="类型"
                prop="alarmType"
                :show-overflow-tooltip="true"
                align="center"
              >
                <template slot-scope="scope">
                  <p
                    :class="
                      scope.row.alarmType == '状态指示'
                        ? 'green'
                        : scope.row.alarmType == '异常信息'
                        ? 'orange'
                        : scope.row.alarmType == '报警信息'
                        ? 'yellow'
                        : 'red'
                    "
                  >
                    {{ scope.row.alarmType }}
                  </p>
                </template>
              </el-table-column>
            </el-table>
            <div class="pagination">
              <el-pagination
                layout="total,prev,pager,next"
                :current-page="notice_page"
                :page-size="notice_size"
                :total="notice_count"
                :pager-count="4"
                @current-change="noticeChangePage"
              ></el-pagination>
            </div>
          </div>
        </li>
        <li>
          <div class="bar">
            <!-- <div class="barbox">
              <ul class="clearfix">
                <li class="pulll_left counter">12581189</li>
                <li class="pulll_left counter">3912410</li>
              </ul>
            </div>
            <div class="barbox2">
              <ul class="clearfix">
                <li class="pulll_left">现场数量统计 </li>
                <li class="pulll_left">系统注册用户数量统计</li>
              </ul>
            </div> -->
          </div>
          <div class="map">
            <div class="map4" id="map_1"></div>
          </div>
        </li>
        <li>
          <div class="boxall" style="height:1.6rem;padding-top:.1rem">
            <div class="alltitle">维护保养设备列表</div>
            <!-- <div class="allnav" id="echart4"></div> -->
            <el-table
              stripe
              border
              :data="maintain_tableData"
              :row-style="{ height: '0' }"
              :cell-style="{ padding: '1px' }"
            >
              <el-table-column
                label="项目编号"
                prop="projectNumber"
                align="center"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                label="保养信息"
                :show-overflow-tooltip="true"
                align="center"
              >
                <template slot-scope="scope">
                  <p>
                    {{
                      scope.row.value == "1"
                        ? "清洗油冷却器"
                        : scope.row.value == "2"
                        ? "检测润滑油"
                        : scope.row.value == "3"
                        ? "切换滤芯"
                        : scope.row.value == "4"
                        ? "更换滤芯"
                        : scope.row.value == "5"
                        ? "清理油雾风机"
                        : scope.row.value == "6"
                        ? "检测主电机轴承温度"
                        : ""
                    }}
                  </p>
                </template>
              </el-table-column>
              <el-table-column
                label="时间"
                prop="ts"
                :show-overflow-tooltip="true"
                align="center"
              ></el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    @click="maintainEdit(scope.row)"
                    type="text"
                    size="small"
                    >清零</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <div class="pagination">
              <el-pagination
                layout="total , prev, pager, next"
                :current-page="maintain_page"
                :page-size="maintain_size"
                :total="maintain_count"
                :pager-count="4"
                @current-change="maintainChangePage"
              ></el-pagination>
            </div>
          </div>
          <div class="boxall" style="height: 1.6rem;padding-top:.1rem">
            <div class="alltitle">检修设备列表</div>
            <!-- <div class="allnav" id="echart5"></div> -->
            <el-table
              stripe
              border
              :data="repair_tableData"
              :row-style="{ height: '0' }"
              :cell-style="{ padding: '1px' }"
            >
              <el-table-column
                label="项目编号"
                prop="projectNumber"
                align="center"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                label="检修信息"
                :show-overflow-tooltip="true"
                align="center"
              >
                <template slot-scope="scope">
                  <p>
                    {{
                      scope.row.value == "1"
                        ? "更换机组润滑油"
                        : scope.row.value == "2"
                        ? "更换机组叶轮"
                        : scope.row.value == "3"
                        ? "更换机组齿轮箱轴承"
                        : scope.row.value == "4"
                        ? "更换主电机驱动端轴承"
                        : scope.row.value == "5"
                        ? "更换主电机非驱动端轴承"
                        : scope.row.value == "6"
                        ? "更换导叶阀"
                        : scope.row.value == "7"
                        ? "更换放空阀"
                        : ""
                    }}
                  </p>
                </template>
              </el-table-column>
              <el-table-column
                label="时间"
                prop="ts"
                :show-overflow-tooltip="true"
                align="center"
              ></el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    @click="repairEdit(scope.row)"
                    type="text"
                    size="small"
                    >清零</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <div class="pagination">
              <el-pagination
                layout="total , prev, pager, next"
                :current-page="repair_page"
                :page-size="repair_size"
                :total="repair_count"
                :pager-count="4"
                @current-change="repairChangePage"
              ></el-pagination>
            </div>
          </div>
          <!-- <div class="boxall" style="height: 1.5rem">
            <div class="alltitle">数据</div>
            <div class="allnav" id="echart6"></div>
          </div> -->
        </li>
      </ul>
    </div>
    <!-- <canvas id="canv" width="100%" height="100%"></canvas> -->
  </div>
</template>
<script>
import "../utils/china.js";
import DataService from "@/api/data";
import map from "../utils/echarts_china.js";
import data from "../utils/echarts_data.js";
import screenfull from "screenfull";
import mqtt from "mqtt";
export default {
  data() {
    return {
      device_status: "3",
      activeName: "-1",
      timer: "",
      time: "",
      Screen: false,
      h: Number,
      device_size: 4,
      device_tableData: [],
      device_page: 1,
      device_count: 0,
      notice_size: 4,
      notice_tableData: [],
      notice_page: 1,
      notice_count: 0,
      maintain_tableData: [],
      maintain_page: 1,
      maintain_size: 4,
      maintain_count: 0,
      repair_tableData: [],
      repair_page: 1,
      repair_size: 4,
      repair_count: 0,
    };
  },
  methods: {
    toProjectScene() {
      this.$router.push("/projectScene");
    },
    //控制
    control(e) {
      this.$router.push({
        path: "/detailInfo",
        query: {
          serial_number: e.collector_no,
          equipmentModel: e.machine_model,
          status: 0,
          geteway_name: e.factory_no,
          item_no: e.project_number,
          // region:e.addr,
          customer: e.terminal_user,
          stable: e.stable,
          device_rank: e.device_rank,
        },
      });
    },
    getDeviceListData() {
      DataService.projectsiteData({
        user_id: this.$store.state.user_id,
        // status:this.activeName,
        device_status: this.device_status,
        page: this.device_page,
        size: this.device_size,
        user_token: this.$store.state.token,
      })
        .then((res) => {
          this.device_tableData = res.data.list;
          this.device_count = Number(res.data.count);
        })
        .catch((err) => {
          this.$message.error(err.msaage);
        });
    },
    deviceChangePage(page) {
      this.device_page = page;
      this.getDeviceListData();
    },
    //全部 离线 在线状态变化
    adtiveNameChange(status) {
      this.device_status = status;
      this.getDeviceListData();
    },
    getNoticeListData() {
      DataService.getAlarmDataAll({
        user_id: this.$store.state.user_id,
        status: 1,
        page: this.notice_page,
        size: this.notice_size,
        user_token: this.$store.state.token,
      })
        .then((res) => {
          this.notice_tableData = res.data.projectSiteList;
          this.notice_count = res.data.count;
        })
        .catch((err) => {
          this.$message.error(err.msaage);
        });
    },
    noticeChangePage(page) {
      this.notice_page = page;
      this.getNoticeListData();
    },
    getMaintainListData() {
      DataService.queryVariableStatusByUserId({
        user_id: this.$store.state.user_id,
        page: this.maintain_page,
        size: this.maintain_size,
        user_token: this.$store.state.token,
        variable: "var40129",
      })
        .then((res) => {
          this.maintain_tableData = res.data.projectSiteList;
          this.maintain_count = res.data.count;
        })
        .catch((err) => {
          this.$message.error(err.msaage);
        });
    },
    maintainChangePage(page) {
      this.maintain_page = page;
      this.getMaintainListData();
    },
    //修改保养状态为正常
    maintainEdit(row) {
      let _this = this;
      this.$confirm(
        '是否将项目编号为"' + row.projectNumber + '"的状态清零?',
        "警告",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(function() {
          DataService.updateVariableValues({
            serialNumber: row.serialNumber,
            user_id: _this.$store.state.user_id,
            variableName: "var40129",
            value: "0",
            username: _this.$store.state.username,
            oldValue: row.value,
            company: "",
            alias: "维护保养信息码",
            factory_no: "",
            id: "",
          })
            .then((res) => {
              _this.$message.success("修改成功");
              _this.getMaintainListData();
            })
            .catch((err) => {
              _this.$message.error(err.message);
            });
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    getRepairListData() {
      DataService.queryVariableStatusByUserId({
        user_id: this.$store.state.user_id,
        page: this.repair_page,
        size: this.repair_size,
        user_token: this.$store.state.token,
        variable: "var40130",
      })
        .then((res) => {
          this.repair_tableData = res.data.projectSiteList;
          this.repair_count = res.data.count;
        })
        .catch((err) => {
          this.$message.error(err.msaage);
        });
    },
    repairChangePage(page) {
      this.repair_page = page;
      this.getRepairListData();
    },
    repairEdit(row) {
      let _this = this;
      this.$confirm(
        '是否将项目编号为"' + row.projectNumber + '"的状态清零?',
        "警告",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(function() {
          DataService.updateVariableValues({
            serialNumber: row.serialNumber,
            user_id: _this.$store.state.user_id,
            variableName: "var40130",
            value: "0",
            username: _this.$store.state.username,
            oldValue: row.value,
            company: "",
            alias: "机组检修信息码",
            factory_no: "",
            id: "",
          })
            .then((res) => {
              _this.$message.success("修改成功");
              _this.getRepairListData();
            })
            .catch((err) => {
              _this.$message.error(err.message);
            });
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    mqttMSG() {
      const options = {
        connectTimeout: 40000,
        clientId: "mqtitId-Home" + Math.random().toFixed(5),
        username: "",
        password: "",
        clean: true,
      };
      this.client = mqtt.connect(this.$wssURL, options);
      if (this.client.connected) {
        this.client.end();
      }
      // mqtt连接
      this.client.on("connect", (e) => {
        console.log("连接成功:");
        this.client.subscribe(`sendMessage/#`, (error) => {
          if (!error) {
            console.log("订阅成功");
          } else {
            console.log("订阅失败");
          }
        });
      });
      // 接收消息处理
      this.client.on("message", (topic, message) => {
        // console.log("收到来自", topic, "的消息", message.toString());
        // console.log(JSON.parse(message.toString()));
        let data = JSON.parse(message.toString());
        this.device_tableData.forEach((el) => {
          if (el.collector_no == data.serialNumber) {
            this.$set(el, "electricCurrent", data.electricCurrent);
            this.$set(el, "pressure", data.pressure);
          }
        });
      });
      // 断开发起重连
      this.client.on("reconnect", (error) => {
        console.log("正在重连:", error);
      });
      // 链接异常处理
      this.client.on("error", (error) => {
        console.log("连接失败:", error);
      });
    },
    screen() {
      //判断是否支持
      if (!screenfull.isEnabled) {
        console.log(screenfull);
        this.$message({
          message: "不支持全屏",
          type: "warning",
        });
        return false;
      } else {
        if (this.Screen == false) {
          this.Screen = true;
          screenfull.toggle(this.$refs.mainbox);
        } else {
          this.Screen = false;
          screenfull.toggle(this.$refs.mainbox);
        }
      }
    },
  },
  created() {
    if (window.location.href.indexOf("code") != -1) {
      let str = window.location.href;
      let index1 = str.indexOf("?");
      let index2 = str.indexOf("#");
      let str1 = str.slice(index1, index2);
      window.location.href = str.replace(str1, "");
    }
  },
  mounted() {
    this.getDeviceListData();
    this.getNoticeListData();
    this.getMaintainListData();
    this.getRepairListData();
    this.mqttMSG();
    let _this = this;
    //  _this.h = document.documentElement.clientWidth;
    // document.documentElement.style.fontSize = _this.h/20 + 'px';
    window.onresize = () => {
      return (() => {
        document.documentElement.style.fontSize = _this.h / 20 + "px";
      })();
    };
    var t = null;
    t = setTimeout(time, 1000); //開始运行
    function time() {
      clearTimeout(t); //清除定时器
      var dt = new Date();
      var y = dt.getFullYear();
      var mt = dt.getMonth() + 1;
      var day = dt.getDate();
      var h = dt.getHours(); //获取时
      var m = dt.getMinutes(); //获取分
      var s = dt.getSeconds(); //获取秒
      _this.$refs.showTime.innerHTML =
        y + "年" + mt + "月" + day + "日" + h + "时" + m + "分" + s + "秒";
      t = setTimeout(time, 1000); //设定定时器，循环运行
    }
    data();
    map();
  },
  watch: {
    h() {
      document.documentElement.style.fontSize = this.h / 20 + "px";
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>

<style lang="scss" scoped>
.home {
  background: url("https://yliiotcloud.obs.cn-east-3.myhuaweicloud.com/22281653304967_.pic_hd.jpg")
    center top;
  background-size: 100% 100%;
  height: calc(100vh - 80px);
  color: #666;
  font-size: 0.1rem;
  padding: 20px 0 !important;
  //  /deep/ .el-table{
  //  font-size: 12px;
  //  }
  /deep/ .el-tag {
    margin: 0 2px;
    width: 40px !important;
    height: 26px;
    font-size: 10px;
    padding: 0;
  }
}
.radio {
  position: absolute;
  left: 180px;
  top: -20px;
  /deep/ span {
    padding: 10px;
    font-size: 16px;
  }
}
.green {
  color: greenyellow;
}
.orange {
  color: orange;
}
.yellow {
  color: yellow;
}
.red {
  color: red;
}
.pagination {
  margin-top: 10px;
}
@import "./comon0.css";
</style>
